export const operations = Object.freeze({
  translate : 'translate',
  resize    : 'resize',
  rotate    : 'rotate',
});

export const bounds = Object.freeze({
  topLeft     : 'topLeft',
  topRight    : 'topRight',
  bottomLeft  : 'bottomLeft',
  bottomRight : 'bottomRight',
});

export const handlersBorderName = 'selectionBorderItem';
